import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth, EventProvider, NotificationProvider } from './context';
import { OfflineNotice } from './components/ui';
import { NotificationDisplay } from './components/ui/NotificationDisplay';
import { AppLayout } from './components/layout';
import {
  WelcomePage,
  RegisterPage,
  ForgotPasswordPage,
  AccountPage,
  CoinPurchasePage,
  PayVendorPage,
  ScanHelpPage,
  HistoryPage,
  EventPage,
  ProfilePage,
  EditProfilePage,
  ShareCoinsPage,
  GiveCoinsPage,
  ReceiveCoinsPage,
  TipVendorPage,
  PaymentMethodsPage,
  VotePage,
} from './pages';
import './App.css';

function AppRoutes() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/" element={<WelcomePage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  return (
    <EventProvider>
      <NotificationProvider>
        <NotificationDisplay />
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/" element={<AccountPage />} />
            <Route path="/buy-coins" element={<CoinPurchasePage />} />
            <Route path="/pay-vendor" element={<PayVendorPage />} />
            <Route path="/scan-help" element={<ScanHelpPage />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/event" element={<EventPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/edit-profile" element={<EditProfilePage />} />
            <Route path="/share-coins" element={<ShareCoinsPage />} />
            <Route path="/give-coins" element={<GiveCoinsPage />} />
            <Route path="/receive-coins" element={<ReceiveCoinsPage />} />
            <Route path="/tip-vendor" element={<TipVendorPage />} />
            <Route path="/payment-methods" element={<PaymentMethodsPage />} />
            <Route path="/vote" element={<VotePage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </NotificationProvider>
    </EventProvider>
  );
}

function App() {
  return (
    <HashRouter>
      <AuthProvider>
        <OfflineNotice />
        <AppRoutes />
      </AuthProvider>
    </HashRouter>
  );
}

export default App;
